// This component displays a color key (legend) for interpreting color-coded
// map layers, such as temperature gradients. It provides a visual reference
// for users to understand the meaning of color scales on the map.

import * as React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import {Badge} from "react-bootstrap";
import Button from "react-bootstrap/Button";

// ColorKeyControl is a React functional component that renders a simple
// color gradient legend with labels for cold, temperate, and hot.
function ColorKeyControl(props) {

    return (
        <div
            className="control-panel-accord color-key-control pt-0"
        >
            {/* Display the labels for the color gradient. */}
            <div className={'d-flex justify-content-between mt-0'}>
                <span>Cold</span><span>Temperate</span><span>Hot</span>
            </div>
            {/* The color-key-gradient class should provide the visual gradient. */}
            <div className='color-key-gradient'> &#8205; </div>
        </div>
    );
}

export default React.memo(ColorKeyControl);
